// extracted by mini-css-extract-plugin
export default {"listGroup":"ScrollableList_listGroup__3yeeG","clickable":"ScrollableList_clickable__rBlZX"};